import { Box, Button, Grid, Typography } from "@mui/material";
import { IRaffle } from "../../store/interfaces/IRaffle";
import { useIsMobileView } from "../../utils/responsive";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import { DoneAll } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Importa useNavigate para la redirección

interface SuccessPurchaseProps {
  activeRaffle: IRaffle;
}

export const SuccessPurchase = ({ activeRaffle }: SuccessPurchaseProps) => {
  const isMobile = useIsMobileView();
  const accountInformation = useAppSelector(
    ({ account }: RootState) => account
  );
  const [counter, setCounter] = useState(5);
  const navigate = useNavigate(); // Hook para la navegación

  useEffect(() => {
    if (counter === 0) {
      navigate("/"); // Redirige cuando el contador llega a 0
      return;
    }
    const timerId = setTimeout(() => setCounter(counter - 1), 1000);
    return () => clearTimeout(timerId); // Limpia el temporizador al desmontar
  }, [counter, navigate]);

  return (
    <Grid container sx={{ background: "#000" }}>
      <Grid item xs={12} padding={isMobile ? 0 : 2}>
        <Grid item xs={12} padding={isMobile ? 0 : 1}>
          <Grid item xs={12} mt={20}>
            <Typography variant="h6" component="div" textAlign={"center"}>
              <img
                src={accountInformation.logo}
                width={200}
                style={{
                  borderRadius: 15,
                }}
                height={200}
                alt=""
              />
            </Typography>
          </Grid>
          <Typography variant="h5" fontWeight={"bold"} textAlign={"center"}>
            {activeRaffle.name}
          </Typography>
        </Grid>
        <Grid item xs={12} paddingTop={2}>
          <Box mb={20} px={10}>
            <Typography textAlign={"center"} variant="h6" color={"white"}>
              Se ha creado la orden de compra, sus números llegarán a su correo
              una vez validemos la transferencia. Debe esperar entre 12 a 24 horas
              para recibir su correo de confirmación.
            </Typography>
            <Box display={"flex"} justifyContent={"center"}>
              <DoneAll sx={{ fontSize: 60 }} color="success" />
            </Box>
            <Typography textAlign={"center"} variant="h6" mt={2}>
              Redirigiendo en {counter} segundos...
            </Typography>
            <Box display={"flex"} justifyContent={"center"} mt={5}>
              <Button variant="contained" href="/">
                VOLVER A COMPRAR
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};
